import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import S from 'commons/styles/sto-list-page.styles';
import { STOItem } from 'commons/types';
import { getSTOReceiveItemsAction } from 'redux-stores/actions';
import { RootReducerInterface } from 'redux-stores/reducers';
import { AppDispatch } from 'redux-stores/store';
import { STO_RECEIVE_ROUTES } from 'routes/constants';

import { STOReceiveListTable } from './components';

export const STOReceiveListPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { assignedSTOItems } = useSelector(
    (state: RootReducerInterface) => state.stoReceiveItem,
  );

  const [filter, setFilter] = useState<string>('');
  const [disableProceedButton, setDisableProceedButton] =
    useState<boolean>(true);
  const [displayedItems, setDisplayedItems] =
    useState<STOItem[]>(assignedSTOItems);

  useEffect(() => {
    dispatch(getSTOReceiveItemsAction());
  }, [dispatch]);

  useEffect(() => {
    setDisplayedItems(assignedSTOItems);
    // set proceed button, disable if any of item that has not finish received
    setDisableProceedButton(
      !!assignedSTOItems.find(
        (item) =>
          item.quantity !==
          item.receive_actual.reduce(
            (total, actual) => total + actual.quantity,
            0,
          ),
      ),
    );
  }, [assignedSTOItems, dispatch]);

  const onFilterChange = (value: string): void => {
    setFilter(value);
    if (value === '') {
      setDisplayedItems(assignedSTOItems);
    } else {
      const filteredIdx: number[] = [];
      const filteredItems = assignedSTOItems.filter((task, idx) => {
        if (task.sku_code.includes(value)) {
          filteredIdx.push(idx);
          return true;
        }
        return false;
      });
      setDisplayedItems(filteredItems);
    }
  };

  return (
    <div>
      <S.ContentWrapper>
        <S.SubtitleWrapper container>
          <S.Subtitle item xs={12} data-testid="STOTextListPick">
            STO Receive List
          </S.Subtitle>
        </S.SubtitleWrapper>
        <S.SearchBar
          placeholder="SKU Number or Scan"
          variant="outlined"
          value={filter}
          onChange={(event) => onFilterChange(event.target.value)}
          inputProps={{
            'data-testid': 'InputListSKU',
          }}
        />

        <STOReceiveListTable stoItems={displayedItems} />
        <S.BlankWhiteSpace />
      </S.ContentWrapper>
      {/* Footer Section */}
      <S.FooterWrapper>
        <S.PrimaryButton
          disabled={disableProceedButton}
          onClick={() => navigate(STO_RECEIVE_ROUTES.SUMMARY)}
          data-testid="BtnListProceed"
        >
          PROCEED
        </S.PrimaryButton>
      </S.FooterWrapper>
    </div>
  );
};
